import React from 'react';
import { useGeneralHooks } from '../../../Hooks/hooks';
import Contacts from '../../Contacts/contacts';
import styles from './mainFooter.module.scss';

const MainFooter: React.FC = () => {
    const { t } = useGeneralHooks();

    const handlePhoneClick = (phoneNumber: string) => {
        window.open(`tel:${phoneNumber}`, '_self');
    };

    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                {/* Logo Section */}
                <div className={styles.logoSection}>
                    <img src="/favicon.png" alt="Mr. Byte Logo" className={styles.logo} />
                    <h2 className={styles.logoTitle}>Mr. Byte</h2>
                    <p className={styles.logoText}>
                        {t('Footer.LogoText', 'Helping businesses grow with smart digital solutions')}
                    </p>
                </div>

                {/* Contact Section */}
                <div className={styles.contactSection}>
                    <h3 className={styles.contactTitle}>
                        {t('Footer.ContactTitle')}
                    </h3>
                    
                    {/* Phone Numbers */}
                    <div className={styles.phoneSection}>
                        <h4 className={styles.phoneTitle}>
                            {t('Footer.PhoneTitle')}
                        </h4>
                        <div className={styles.phoneNumbers}>
                            <button 
                                className={styles.phoneButton}
                                onClick={() => handlePhoneClick('+374-94-173-591')}
                            >
                                ☎️ +374-94-173-591
                            </button>
                            {/* <button 
                                className={styles.phoneButton}
                                onClick={() => handlePhoneClick('+374-XX-XXX-XXX')}
                            >
                                ☎️ +374-XX-XXX-XXX
                            </button> */}
                        </div>
                    </div>

                    {/* Social Media */}
                    {/* <div className={styles.socialSection}>
                        <h4 className={styles.socialTitle}>
                            {t('Footer.SocialTitle')}
                        </h4>
                        <Contacts />
                    </div> */}
                </div>

            </div>

            {/* Bottom Bar */}
            <div className={styles.bottomBar}>
                <div className={styles.container}>
                    <p className={styles.copyright}>
                        © 2024 Mr. Byte. {t('Footer.Copyright')}
                    </p>
                    <div className={styles.bottomLinks}>
                        <a href="#privacy" className={styles.bottomLink}>
                            {t('Footer.Privacy')}
                        </a>
                        <a href="#terms" className={styles.bottomLink}>
                            {t('Footer.Terms')}
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default MainFooter
